var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 32H22.75C23.612 32 24.4386 31.6629 25.0481 31.0627C25.6576 30.4626 26 29.6487 26 28.8V9.6L16.25 0H3.25C2.38805 0 1.5614 0.337142 0.951903 0.937258C0.34241 1.53737 0 2.35131 0 3.2V28.8C0 29.6487 0.34241 30.4626 0.951903 31.0627C1.5614 31.6629 2.38805 32 3.25 32ZM14.625 3.2L22.75 11.2H14.625V3.2ZM7.3125 14.4C7.6327 14.4001 7.94975 14.4623 8.24554 14.5831C8.54133 14.7038 8.81007 14.8807 9.03641 15.1037C9.26275 15.3268 9.44227 15.5915 9.56471 15.8828C9.68714 16.1741 9.75011 16.4863 9.75 16.8016C9.74989 17.1169 9.68672 17.429 9.56408 17.7203C9.44145 18.0115 9.26175 18.2761 9.03526 18.499C8.80877 18.7218 8.53991 18.8986 8.24404 19.0192C7.94817 19.1397 7.63108 19.2017 7.31087 19.2016C6.66419 19.2014 6.04409 18.9482 5.58697 18.4979C5.12985 18.0475 4.87316 17.4367 4.87337 16.8C4.87359 16.1633 5.13069 15.5527 5.58811 15.1026C6.04554 14.6525 6.66582 14.3998 7.3125 14.4ZM8.125 22.4L10.7201 24.5808L14.625 17.6L21.125 27.2H4.875L8.125 22.4Z",
    fill: "#FFB703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d5f9f7cd06b75250ae042c2c76449e4e.svg";
export { ForwardRef as ReactComponent };